<div class="p-3  fix-width">
    <div *ngIf="shareObject.data.type === 'list' || shareObject.data.type === 'deleted'">
        <h1 class="fw-bold fs-4 mb-3">{{'title_time_keeping_manager'|translate}}</h1>
        <div>
            <div class="mt-4 border-bottom">
                <!-- Search bar -->
                <div class="w-100 mb-2">
                    <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                        <div class="d-flex align-items-center gap-2">
                            <!-- button back  -->
                            <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-warning  rounded-1"
                                (click)="sharedService.back()">
                                <i class="bi bi-arrow-left"></i>
                                <span class="ms-2">{{'btn_back'|translate}}</span>
                            </button>
                            <button [disabled]="shareObject.isLoading"
                                *ngIf="  selectionService.getSelectedRows().size> 0 && shareObject.data.type=='list'"
                                class="btn btn-sm btn-danger rounded-1"
                                (click)="deleteItem(selectionService.getSelectedRows())" role="button">
                                <i class="bi bi-archive"></i>
                                <span class="ms-2">{{'btn_soft_delete'|translate}}</span>
                            </button>
                            <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-info rounded-1"
                                (click)="clear()" role="button">
                                <i class="bi bi-arrow-clockwise"></i>
                                <span class="ms-2">{{'btn_clear'|translate}}</span>
                            </button>
                            <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
                                (click)="shareObject.filterBox = true" role="button">
                                <i class="bi bi-funnel"></i>
                                <span class="ms-2"> {{'btn_filter'|translate}} </span>
                            </button>

                        </div>
                    </div>
                    <!-- search box -->
                    <div style="z-index: 1050; width: 600px" class="position-absolute">
                        <form *ngIf="shareObject.filterBox===true" [formGroup]="shareObject.filterForm"
                            class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
                            <div class="row g-2">
                                <!-- timesheet keyword -->
                                <div class="col-md-12">
                                    <label class="form-label fw-bold"
                                        for="employee">{{'filter_keyword'|translate}}</label>
                                    <input type="text" class="form-control form-control-sm" formControlName="employee"
                                        id="employee">
                                </div>
                                <!-- timekeeping type -->
                                <div class="mb-3 col-md-6">
                                    <label for="timekeeping"
                                        class="form-label fw-bold">{{'timekeeping_type'|translate}}</label>
                                    <select class="form-select form-select-sm" formControlName="timekeeping"
                                        id="timekeeping">
                                        <option *ngFor="let item of sharedService.env.timekeepingTypes"
                                            [value]="item.value">
                                            {{item.name|translate}}</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
                                    <select class="form-select form-select-sm" formControlName="employeeGroup"
                                        id="group">
                                        <option value="">{{'filter_group_all'|translate}}</option>
                                        <option *ngFor="let group of shareObject.employeeGroups" value="{{group.id}}">
                                            {{group.name}}
                                        </option>
                                    </select>
                                </div>
                                <!-- timesheet keyword -->
                                <div class="col-md-3">
                                    <div class=" d-flex gap-2" id="btns">
                                        <button class="btn btn-primary btn-sm rounded-1"
                                            (click)="onSearch()">{{'btn_filter'|translate}}</button>
                                        <button class="btn btn-secondary btn-sm rounded-1"
                                            (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- filter result -->
                <div class="d-flex gap-2 mb-3 mt-2" *ngIf="shareObject.filters && shareObject.filters.length > 0">
                    <span *ngFor="let item of shareObject.filters">
                        <span type="button" *ngIf="item.key !=='limit'"
                            class="btn btn-outline-danger btn-sm rounded-1 position-relative py-1 fs-8 fw-bold"
                            (click)="filterClear(item)">
                            {{item.displayValue}}
                        </span>
                    </span>
                </div>

            </div>
            <div class="fix-height">
                <table class="table table-hover table-striped table-sm">
                    <thead class="sticky-top bg-white">
                        <tr>
                            <th style="width: 50px;">
                                <div class="form-check">
                                    <input class="form-check-input" role="button" type="checkbox"
                                        [checked]="selectionService.isAllSelected(shareObject.users)"
                                        (change)="selectionService.toggleSelectAll($event,shareObject.users)"
                                        id="checkall">
                                    <label class="form-check-label" for="checkall"></label>
                                </div>
                            </th>
                            <!-- <th scope="col">{{'calendar_work_date'|translate}}</th> -->
                            <!-- <th scope="col">{{'employee_group'|translate}}</th> -->
                            <th scope="col">{{'timekeeping_employee'|translate}}</th>
                            <th scope="col">{{'timekeeping_type'|translate}}</th>
                            <th scope="col">{{'timekeeping_work_hour'|translate}}</th>
                            <th scope="col">{{'timekeeping_overtime_rate'|translate}}</th>
                            <th scope="col">{{'timekeeping_standard'|translate}}</th>
                            <!-- <th scope="col">{{'calendar_status'|translate}}</th> -->
                            <th scope="col">{{'use_action'|translate}}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="shareObject.users && shareObject.users.length > 0 && !shareObject.isLoading">
                        <tr *ngFor="let item of shareObject.users; let i = index">
                            <td>
                                <div class="form-check">
                                    <input class="form-check-input" role="button" type="checkbox"
                                        [checked]="selectionService.getSelectedRows().has(i)"
                                        (click)="onRowClick($event, i)">
                                </div>
                            </td>
                            <td>
                                <span>
                                    <span class="badge text-bg-primary me-2">{{item?.profile?.employeeId}}</span>
                                    <span class="me-2 fw-bold">{{item?.profile?.name}}</span>
                                    <span
                                        class="badge text-bg-light text-muted">{{item?.profile?.employeeGroup?.name}}</span>
                                </span>
                            </td>
                            <td>
                                <div>
                                    <span *ngIf="item?.timekeeping" role="button"
                                        class="badge text-bg-primary rounded-pill me-1">
                                        {{item?.timekeeping?.typeText|translate}}
                                    </span>
                                    <span *ngIf="!item?.timekeeping" role="button"
                                        class="fst-italic badge text-bg-secondary rounded-pill me-1">
                                        {{'no_timekeeping'|translate}}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <span *ngIf="item?.timekeeping?.workhours" role="button" class="me-1 fw-bold">
                                        {{item?.timekeeping?.workhours}}h
                                    </span>
                                    <span *ngIf="!item?.timekeeping?.workhours" role="button" class="">
                                        0h
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <span *ngIf="item?.timekeeping?.overtimeRate" role="button" class="me-1 fw-bold">
                                        {{item?.timekeeping?.overtimeRate}}
                                    </span>
                                    <span *ngIf="!item?.timekeeping?.overtimeRate" role="button" class="me-1 fw-bold">
                                        0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <span *ngIf="item?.timekeeping?.standard" role="button" class="me-1 fw-bold">
                                        {{item?.timekeeping?.standard}}
                                    </span>
                                    <span *ngIf="!item?.timekeeping?.standard" role="button" class="me-1 fw-bold">
                                        0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'list'">
                                    <span class="btn btn-success btn-sm rounded-1 py-0" *ngIf="!item?.timekeeping"
                                        (click)="getItemValue(item)">
                                        <i class="bi bi-plus-circle me-2"></i>
                                        {{'btn_add'|translate}}
                                    </span>
                                    <span class="btn btn-primary btn-sm rounded-1 py-0" *ngIf="item?.timekeeping"
                                        (click)="getItemValue(item)">
                                        <i class="bi bi-pencil-square me-2"></i>
                                        {{'btn_edit'|translate}}
                                    </span>
                                    <span *ngIf="item?.timekeeping" class="btn btn-danger btn-sm rounded-1 py-0"
                                        (click)="deleteItem([i])">
                                        <i class="bi bi-archive me-2"></i>
                                        {{'btn_soft_delete'|translate}}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <caption *ngIf="shareObject.items && shareObject.items.length === 0 && !shareObject.isLoading">
                        <div class="text-center">
                            {{'no_calendar_found'|translate}}
                        </div>
                    </caption>
                    <caption *ngIf="shareObject.isLoading">
                        <div class="text-center">
                            <div class="spinner-border spinner-border-sm text-secondary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </caption>
                </table>
            </div>
            <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
                (changePage)="onPageChange($event)"></app-pagination>
        </div>
    </div>
    <div *ngIf="shareObject.data.type === 'table'">

        <!-- tạo 3 tab gồm bảng công nhật, bảng công giờ, bảng công KPI -->
        <div class="hide-on-print">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': shareObject.active === 'day'}"
                        [attr.aria-current]="shareObject.active === 'day' ? 'page' : null"
                        [routerLink]="shareObject.tableURL" [queryParams]="{ type: 'day' }">
                        {{'timekeeping_day'|translate}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': shareObject.active === 'hour'}"
                        [attr.aria-current]="shareObject.active === 'hour' ? 'page' : null"
                        [routerLink]="shareObject.tableURL" [queryParams]="{ type: 'hour' }">
                        {{'timekeeping_hour'|translate}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': shareObject.active === 'kpi'}"
                        [attr.aria-current]="shareObject.active === 'kpi' ? 'page' : null"
                        [routerLink]="shareObject.tableURL" [queryParams]="{ type: 'kpi' }">
                        {{'timekeeping_kpi'|translate}}
                    </a>
                </li>
            </ul>

        </div>

        <div class="mb-3 mt-4 d-flex gap-2 hide-on-print">
            <div>
                <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
                    (click)="window.print()">
                    <i class="bi bi-print"></i>
                    <span class="ms-2">{{'btn_print'|translate}}</span>
                </button>
            </div>
            <div>
                <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
                    (click)="exportTimekeepingToExcel()">
                    <span class="ms-2">{{'btn_export_excel'|translate}}</span>
                </button>
            </div>
            <div>
                <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
                    (click)="exportKpiToExcel()">
                    <span class="ms-2">{{'btn_export_kpi'|translate}}</span>
                </button>
            </div>
            <div>
                <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
                    (click)="shareObject.filterBox = true" role="button">
                    <i class="bi bi-funnel"></i>
                    <span class="ms-2"> {{'btn_filter'|translate}} </span>
                </button>
            </div>
            <div>
                <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1" (click)="clear()"
                    role="button">
                    <i class="bi bi-arrow-clockwise"></i>
                    <span class="ms-2"> {{'btn_clear'|translate}} </span>
                </button>
            </div>
            <div style="z-index: 1050; width: 600px" class="position-absolute">
                <form *ngIf="shareObject.filterBox===true" [formGroup]="shareObject.filterForm"
                    class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
                    <div class="row g-2">
                        <div class="col-md-12">
                            <label class="form-label fw-bold" for="group">{{'search_employee'|translate}}</label>
                            <input type="text" class="form-control form-control-sm" formControlName="employee"
                                id="employee">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
                            <select class="form-select form-select-sm" formControlName="employeeGroup" id="group">
                                <option value="">{{'filter_group_all'|translate}}</option>
                                <option *ngFor="let group of shareObject.employeeGroups" value="{{group.id}}">
                                    {{group.name}}
                                </option>
                            </select>
                        </div>
                        <!-- page size -->
                        <div class="col-md-6">
                            <label class="form-label fw-bold" for="pagesize">{{"page_size"|translate}}</label>
                            <select class="form-select form-select-sm" formControlName="limit" id="pagesize">
                                <option *ngFor="let size of sharedService.env.pageSize" value="{{size}}">
                                    {{size}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
                            <input type="date" class="form-control form-control-sm" formControlName="start" id="start">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
                            <input type="date" class="form-control form-control-sm" formControlName="end" id="end">
                        </div>
                        <!-- employee keyword -->
                        <div class="col-md-3">
                            <label class="form-label fw-bold mb-4" for="btns"></label>
                            <div class=" d-flex gap-2" id="btns">
                                <button class="btn btn-primary btn-sm rounded-1"
                                    (click)="onSearch()">{{'btn_filter'|translate}}</button>
                                <button class="btn btn-secondary btn-sm rounded-1"
                                    (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                                <!-- <button class="btn btn-primary btn-sm rounded-1"
                  (click)="refresh()">{{'btn_clear'|translate}}</button> -->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- filter result -->
        <div class="d-flex gap-2 mb-3 mt-2" *ngIf="shareObject.filters && shareObject.filters.length > 0">
            <span *ngFor="let item of shareObject.filters">
                <span *ngIf="item.key!='limit'" type="button"
                    class="btn btn-outline-danger btn-sm rounded-1 position-relative py-1 fs-8 fw-bold"
                    (click)="filterClear(item)">
                    {{item.displayValue}}
                </span>
            </span>
        </div>

        <div class="mt-3">
            <!-- Hiển thị bảng công nhật -->
            <div *ngIf="shareObject.active === 'day'">
                <h1 class="fw-bold fs-4 text-uppercase mb-3">
                    <span class="me-2">{{"title_table_timekeeping_day"|translate}}</span>
                    <span>{{shareObject.timekeepingOfMonth}}</span>
                </h1>
                <div *ngIf="shareObject.isGetdata">
                    <div class="">
                        <div class="spinner-border spinner-border-sm text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!shareObject.isGetdata">
                    <div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-striped table-hover bg-white">
                                <thead class="thead-dark employee-name">
                                    <tr>
                                        <th class="fixed-column" style="width: 400px !important" scope="col">Nhân viên
                                        </th>
                                        <th *ngFor="let day of shareObject.daysArray" scope="col"
                                            [style.width]="'calc((100% - 480px) / ' + shareObject.daysArray.length + ')'"
                                            class="text-center">{{ day.text }}
                                        </th>
                                        <th class="text-center">{{'total'|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody
                                    *ngIf="shareObject.timekeepingData && shareObject.timekeepingData.length > 0 && !shareObject.isGetdata">
                                    <tr *ngFor="let employee of shareObject.timekeepingData; let i = index"
                                        class="{{i%20===0?'page-break':''}}">
                                        <th class="fixed-column" scope="row" style="width: 400px !important">
                                            <div *ngIf="employee.timekeepings" class="position-relative">
                                                <span class="employee">{{ employee.profile?.name }}</span>
                                            </div>
                                        </th>
                                        <td *ngFor="let day of shareObject.daysArray"
                                            routerLink="/user/employee/attendance/history" [queryParams]="{ 
                                                employeeId: employee.profile.employeeId, 
                                                day: day.date }">
                                            <div class="text-center">
                                                <span
                                                    class="{{employee.timekeepings[day.num]=='P'?'text-warning':''}}">{{employee.timekeepings[day.num]}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-center">
                                                <span class="text-primary fw-bold text-center">
                                                    {{employee.timekeepingTotal}}
                                                </span>
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>
                                <caption
                                    *ngIf="shareObject.timekeepingData && shareObject.timekeepingData.length == 0 && !shareObject.isLoading">
                                    <span class="text-danger fw-bold fs-5">{{'no_data'|translate}}</span>
                                </caption>
                                <caption *ngIf="shareObject.isLoading">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </caption>
                            </table>
                        </div>
                    </div>
                    <div class="hide-on-print">
                        <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
                            (changePage)="onPageChange($event)"></app-pagination>
                    </div>
                </div>
            </div>
            <!-- Hiển thị bảng công giờ -->
            <div *ngIf="shareObject.active === 'hour'">
                <h1 class="fw-bold fs-4 text-uppercase mb-3">
                    {{"title_table_timekeeping_hour"|translate}}</h1>
                <div *ngIf="shareObject.isGetdata">
                    <div class="">
                        <div class="spinner-border spinner-border-sm text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!shareObject.isGetdata">
                    <div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-striped table-hover bg-white">
                                <thead class="thead-dark employee-name">
                                    <tr>
                                        <th class="fixed-column w-30" scope="col">Nhân viên</th>
                                        <th *ngFor="let day of shareObject.daysArray" scope="col" style="width: 2.7%"
                                            class="text-center">{{ day.text }}
                                        </th>
                                        <th class="text-center">{{'total'|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody
                                    *ngIf="shareObject.timekeepingData && shareObject.timekeepingData.length > 0 && !shareObject.isGetdata">
                                    <tr *ngFor="let employee of shareObject.timekeepingData; let i = index"
                                        class="{{i%20===0?'page-break':''}}">
                                        <th class="fixed-column" scope="row">
                                            <div *ngIf="employee.timekeepings" class="position-relative">
                                                <span class="employee">{{ employee.profile?.name }}</span>
                                            </div>
                                        </th>
                                        <td *ngFor="let day of shareObject.daysArray"
                                            routerLink="/user/employee/attendance/history" [queryParams]="{ 
                                                employeeId: employee.profile.employeeId, 
                                                day: day.date }">
                                            <div class="text-center">
                                                <span
                                                    class="{{employee.timekeepings[day.num]=='P'?'text-warning fw-bold':''}}">
                                                    {{employee.timekeepings[day.num]}}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-center">
                                                <span class="text-primary fw-bold text-center">
                                                    {{employee.timekeepingTotal}}
                                                </span>
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>
                                <caption
                                    *ngIf="shareObject.timekeepingData && shareObject.timekeepingData.length == 0 && !shareObject.isLoading">
                                    <span class="text-danger fw-bold fs-5">{{'no_data'|translate}}</span>
                                </caption>
                                <caption *ngIf="shareObject.isLoading">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </caption>
                            </table>
                        </div>
                    </div>
                    <div class="hide-on-print">
                        <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
                            (changePage)="onPageChange($event)"></app-pagination>
                    </div>
                </div>
            </div>
            <!-- Hiển thị bảng công KPI -->
            <div *ngIf="shareObject.active === 'kpi'">
                <h1 class="fw-bold text-uppercase fs-4 mb-3">{{'salary_kpi_overview_title'|translate}}</h1>
                <div>
                    <div class="table-responsive">
                        <table class="table table-bordered border bg-white">
                            <thead class="thead-dark employee-name">
                                <tr>
                                    <th class="fixed-column" scope="col" style="min-width:300px">Nhân viên</th>
                                    <th class="fixed-column" scope="col" style="min-width:100px">Đơn vị</th>
                                    <th *ngFor="let day of shareObject.daysArray" scope="col" style="min-width:50px"
                                        class="text-center">{{ day.text}}
                                    </th>
                                    <th class="text-center fixed-column" style="min-width:50px">{{'total'|translate}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody *ngIf="shareObject.items && shareObject.items.length > 0">
                                <tr *ngFor="let employee of shareObject.items" class="align-middle">
                                    <th class="fixed-column" scope="row">
                                        <div class="position-relative">
                                            <div class="employee">{{ employee.profile?.name }}</div>
                                        </div>
                                    </th>
                                    <td class="p-0 fixed-column">
                                        <table *ngIf="employee?.units?.length > 0"
                                            class="table text-start m-0 table-sm table-hover fs-7 col-5">
                                            <tbody>
                                                <tr *ngFor="let item of employee?.units; let i = index">
                                                    <td class="{{i==employee?.units.length-1 ? 'border-0' : ''}}">
                                                        <span>{{item.name}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>

                                    <td *ngFor="let day of shareObject.daysArray" class="p-0">
                                        <div class="d-flex justify-content-between">
                                            <table *ngIf="employee?.kpis[day.num]?.length > 0"
                                                class="table text-start m-0 table-sm table-hover fs-7">
                                                <tbody>
                                                    <tr *ngFor="let item of employee?.kpis[day.num]; let i = index"
                                                        routerLink="/user/employee/formula/salary/kpi/list"
                                                        [queryParams]="{
                                                            employeeId: employee.profile.employeeId, 
                                                            day: item?.date,
                                                            }">
                                                        <td
                                                            class="text-end {{i==employee?.totalByUnit.length-1 ? 'border-0' : ''}}">
                                                            <span>{{item.quantity }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-end w-100" *ngIf="employee?.kpis[day.num]?.length == 0">0</div>
                                    </td>
                                    <td class="p-0 fixed-column">
                                        <table class="table text-start m-0 table-sm table-hover fs-7"
                                            *ngIf="employee?.totalByUnit.length > 0">
                                            <tbody>
                                                <tr *ngFor="let item of employee?.totalByUnit; let i =index">
                                                    <td
                                                        class="{{i==employee?.totalByUnit.length-1 ? 'border-0' : ''}} text-end fw-bold">
                                                        {{item.quantity }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="text-end fw-bold" *ngIf="employee?.totalByUnit.length == 0">0</div>
                                    </td>
                                </tr>
                            </tbody>
                            <caption
                                *ngIf="shareObject.items && shareObject.items.length == 0 && !shareObject.isLoading">
                                <span class="text-danger fw-bold fs-5">{{'no_data'|translate}}</span>
                            </caption>
                            <caption *ngIf="shareObject.isLoading">
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </caption>
                        </table>
                    </div>

                    <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
                        (changePage)="onPageChange($event)"></app-pagination>
                </div>
            </div>
        </div>

    </div>
</div>
<!-- modal add work calendar -->
<div class="modal" id="add-timekeeping" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{'timesheet_select'|translate}} {{shareObject?.employeeChecked?.profile?.name}}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="formHandle">
                    <div class="mb-3">
                        <label for="type" class="form-label">{{'timekeeping_type'|translate}}</label>
                        <select class="form-select form-select-sm" formControlName="type" id="type">
                            <option *ngFor="let item of shareObject.timekeepingTypes" [value]="item.value">
                                {{item.name|translate}}</option>
                        </select>
                    </div>
                    <div class="mb-3"
                        *ngIf="formHandle.value.type != constants.TIMEKEEPING.NONE && formHandle.value.type != constants.TIMEKEEPING.KPI">
                        <label for="workhours" class="form-label">{{'timekeeping_work_hour'|translate}}</label>
                        <input type="number" class="form-control form-control-sm" formControlName="workhours"
                            id="workhours">
                    </div>
                    <div class="mb-3"
                        *ngIf="formHandle.value.type == constants.TIMEKEEPING.DAY || formHandle.value.type == constants.TIMEKEEPING.DAY_KPI">
                        <label for="standard" class="form-label">{{'timekeeping_standard'|translate}}</label>
                        <input type="number" class="form-control form-control-sm" formControlName="standard"
                            id="standard">
                    </div>
                    <div class="mb-3"
                        *ngIf="formHandle.value.type != constants.TIMEKEEPING.NONE && formHandle.value.type != constants.TIMEKEEPING.KPI">
                        <label for="overtimeRate" class="form-label">{{'timekeeping_overtime_rate'|translate}}</label>
                        <input type="number" class="form-control form-control-sm" formControlName="overtimeRate"
                            id="overtimeRate">
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    {{'btn_close'|translate}}
                </button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()">{{'btn_save'|translate}}</button>
            </div>
        </div>
    </div>
</div>